@if (videoProvider === "twentythreespot") {
  <div [id]="'ttspot' + videoId"></div>
} @else {
  @if (!useAspectRatio && !displayAsBoxInGrid) {
    @if (thumbnailImage && hideDetails) {
      <dotcom-frontend-image
        [image]="thumbnailImage"
        class="box-block__image"
      />
    }

    @if (modalComponent && playInModal && hideDetails) {
      <dotcom-frontend-loader [componentData]="modalComponent" parent="video" />
    }

    @if (!playInModal && hideDetails) {
      <ng-container [ngTemplateOutlet]="videoTemplate"></ng-container>
    }
  } @else if (displayAsBoxInGrid) {
    <div class="video-block display-as-box-ingrid box-shadow" [class]="parent">
      <div lgRow class="video-block__video-wrapper">
        <div [lgColMd]="videoSize" [lgColSm]="12">
          <div class="aspect-ratio">
            <div class="aspect-ratio__16-9"></div>
            <div class="aspect-ratio__content">
              @if (thumbnailImage && !loadVideo) {
                <dotcom-frontend-image [image]="thumbnailImage" />
              }

              <ng-container [ngTemplateOutlet]="videoTemplate"></ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="video-block__heading-wrapper">
        <ng-container [ngTemplateOutlet]="videoHeadingTemplate"></ng-container>
      </div>
      <div class="video-block__details-wrapper">
        <ng-container [ngTemplateOutlet]="videoDetailsTemplate"></ng-container>
      </div>
    </div>
  } @else {
    <div
      class="video-block"
      [class]="{ 'video-block__with-registration': registrationRequired }"
    >
      @if (!hideDetails && parent !== "modal") {
        <div lgRow>
          <div [lgColMd]="textSize" [lgColSm]="12">
            @if (headingComponent) {
              <dotcom-frontend-loader [componentData]="headingComponent" />
            }

            @if (bodyText) {
              <div
                [innerHTML]="bodyText | safeHtml"
                [wysiwygContainer]="'Video Component'"
                class="wysiwyg video-block__body-text"
                dotcomFrontendWysiwyg
              ></div>
            }
          </div>
        </div>
      }

      <div lgRow>
        <div
          [lgColMd]="videoSize"
          [lgColSm]="12"
          [ngClass]="{ 'thumbnail-image': registrationRequired && !loadVideo }"
        >
          <div [class]="!registrationRequired ? 'aspect-ratio' : ''">
            @if (!registrationRequired) {
              <div class="aspect-ratio__16-9"></div>
            }
            <div [class]="!registrationRequired ? 'aspect-ratio__content' : ''">
              @if (thumbnailImage && !loadVideo) {
                <dotcom-frontend-image [image]="thumbnailImage" />
              }

              <ng-container [ngTemplateOutlet]="videoTemplate"></ng-container>
            </div>
          </div>
        </div>
      </div>

      @if (parent === "modal" && !registrationRequired) {
        <div lgRow>
          <div [lgColMd]="12" [lgColSm]="12">
            @if (headingComponent) {
              <dotcom-frontend-loader [componentData]="headingComponent" />
            }

            @if (bodyText) {
              <div
                [innerHTML]="bodyText | safeHtml"
                [wysiwygContainer]="'Video Component'"
                class="wysiwyg video-block__body-text"
                dotcomFrontendWysiwyg
              ></div>
            }
          </div>
        </div>
      }

      @if (!hideDetails && !registrationRequired) {
        <ng-container [ngTemplateOutlet]="videoDetailsTemplate"></ng-container>
      }
    </div>
  }
}

<ng-template #videoTemplate>
  @if (thumbnailImage && !playInModal) {
    <div (click)="playVideo($event)" class="video-block__play-area">
      <div
        (keyup)="playVideo($event)"
        class="video-block__play-button"
        tabindex="0"
      >
        <lg-icon [name]="'play'" />
      </div>
    </div>
    @if (registrationRequired) {
      <div class="video-block__registration-required">
        Registration required
      </div>
    }
  }

  @if (videoProvider === "brighttalk" && loadVideo && !playInModal) {
    <div
      [class]="
        'jsBrightTALKEmbedContainer-' +
        blockId +
        ' video-block__iframe-container'
      "
    >
      <object class="BrightTALKEmbed">
        <param name="player" value="chromeless_player" />
        <param name="domain" value="http://www.brighttalk.com" />
        <param [value]="channelId" name="channelid" />
        <param [value]="videoId" name="communicationid" />
        <param [value]="autoPlay" name="autoStart" />
        <param name="theme" value="generic.swf" />
        <param name="showTitleInClickToPlay" value="false" />
        <param name="jsAnalyticsMethod" value="analytics" />
      </object>
    </div>
  }

  @if (videoProvider === "twentythree" && loadVideo && !playInModal) {
    <div class="video-block__iframe-container">
      <iframe
        [src]="this.src"
        aria-label="Video Player"
        style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
        frameborder="0"
        scrolling="no"
        allowfullscreen="allowfullscreen"
        mozallowfullscreen="allowfullscreen"
        webkitallowfullscreen="allowfullscreen"
      >
      </iframe>
    </div>
  }

  <div class="video-block__iframe-container">
    @if (videoProvider === "youtube") {
      <div [id]="'js-youtube-video' + blockId"></div>
    }
  </div>

  @if (modalComponent && playInModal) {
    <dotcom-frontend-loader [componentData]="modalComponent" parent="video" />
  }
</ng-template>

<ng-template #videoHeadingTemplate>
  <div lgRow>
    <div [lgColMd]="12" [lgColSm]="12">
      @if (headingComponent) {
        <dotcom-frontend-loader [componentData]="headingComponent" />
      }
    </div>
  </div>
</ng-template>

<ng-template #videoDetailsTemplate>
  <div lgRow>
    <div [lgColMd]="textSize" [lgColSm]="12">
      <p class="video-block__video-details">
        {{ caption }} {{ caption && "/" }}
        {{ publishDate | date: "dd LLL y" }}
        {{ publishDate && "/" }}

        @if (durationMinutes && durationSeconds) {
          <span>
            {{ durationMinutes | number: "2.0-0" }}:{{
              durationSeconds | number: "2.0-0"
            }}
          </span>
        }
      </p>

      @if (transcript && !displayAsBoxInGrid) {
        <lg-accordion [headingLevel]="4">
          <lg-accordion-item
            (closed)="recordTranscriptAnalytics('Close')"
            (opened)="recordTranscriptAnalytics('Open')"
          >
            <lg-accordion-panel-heading>
              <lg-icon [name]="'page'" />
              <span> Transcript </span>
            </lg-accordion-panel-heading>
            <div class="lg-accordion__panel--overflow-container">
              <div
                [innerHTML]="transcript | safeHtml"
                [wysiwygContainer]="'Video Component'"
                class="wysiwyg"
                dotcomFrontendWysiwyg
              ></div>
            </div>
          </lg-accordion-item>
        </lg-accordion>
      }

      @if (ctaButtons && parent !== "modal") {
        <div
          [ngClass]="{ 'video-block__cta-buttons--link-list': isLinkList }"
          class="video-block__cta-buttons"
        >
          @if (!isLinkList && ctaButtons) {
            @for (button of ctaButtons; let i = $index; track i) {
              <dotcom-frontend-loader [componentData]="button" />
            }
          }

          @if (isLinkList && ctaButtons) {
            <dotcom-frontend-loader [componentData]="ctaButtons" />
          }
        </div>
      }
    </div>
  </div>
</ng-template>
